// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.extraction__container{
    width: 1150px;
    height: 100%;
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    @media screen and (max-width: 600px) {
        flex-direction: column;
        width: 100%;
       } 
}
.extraction__left{
    display: flex;
    padding-top: 40px;
}
.extraction__right{
    display: flex;
    flex-direction: column;
    margin-left: 170px;
    width: 100%;
    padding-top: 120px;
    @media screen and (max-width: 600px) {
        margin-left: 0;
        
       } 
}
.extraction__title{
    text-align: left;
    color: #1E1C1A;
    font-family: Roboto;
    font-size: 40px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 50px;
    margin: 0;
}
.extraction__text{
    color: #1E1C1A;
    font-family: Roboto;
    font-size: 19px;
    letter-spacing: 0;
    line-height: 30px;
    margin-top: 35px;
    text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/Extraction/Extraction.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd;QACI,sBAAsB;QACtB,WAAW;OACZ;AACP;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB;QACI,cAAc;;OAEf;AACP;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".extraction__container{\n    width: 1150px;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    margin: 0 auto;\n    @media screen and (max-width: 600px) {\n        flex-direction: column;\n        width: 100%;\n       } \n}\n.extraction__left{\n    display: flex;\n    padding-top: 40px;\n}\n.extraction__right{\n    display: flex;\n    flex-direction: column;\n    margin-left: 170px;\n    width: 100%;\n    padding-top: 120px;\n    @media screen and (max-width: 600px) {\n        margin-left: 0;\n        \n       } \n}\n.extraction__title{\n    text-align: left;\n    color: #1E1C1A;\n    font-family: Roboto;\n    font-size: 40px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 50px;\n    margin: 0;\n}\n.extraction__text{\n    color: #1E1C1A;\n    font-family: Roboto;\n    font-size: 19px;\n    letter-spacing: 0;\n    line-height: 30px;\n    margin-top: 35px;\n    text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
